import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSmsEditionEngagementStats as GetSmsEditionEngagementStatsQuery,
    GetSmsEditionEngagementStatsVariables as GetSmsEditionEngagementStatsVariables,
    GetSmsEditionEngagementStats_smsEdition as SmsEdition,
} from 'nutshell-graphql-types';

import GET_SMS_EDITION_ENGAGEMENT_STATS from '../queries/get-sms-edition-engagement-stats.graphql';

export const useGetSmsEditionEngagementStats = (
    editionId: string,
    pollTimeout?: number | null
): {
    smsEdition: SmsEdition | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetSmsEditionEngagementStatsQuery,
        GetSmsEditionEngagementStatsVariables
    >(GET_SMS_EDITION_ENGAGEMENT_STATS, {
        variables: {
            editionId,
        },
        pollInterval: pollTimeout || undefined,
    });

    const smsEdition = data ? data.smsEdition : null;

    return {
        smsEdition,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
